import Request from './RequestHandler.js'

export default {
  index (params) {
    return Request.make('get', 'sets', params)
  },
  show (id, params) {
    return Request.make('get', 'sets/' + id, params)
  },
  create (params) {
    return Request.make('post', 'sets', params)
  },
  patch (id, params) {
    return Request.make('patch', 'sets/' + id, params)
  },
  destroy (id) {
    return Request.make('delete', 'sets/' + id)
  },
  filter (params) {
    return Request.make('get', 'sets', params)
  }
}
